module.exports = __webpack_public_path__ + "img/1457445409.1468a977.jpg";